import $ from "jquery";
import Mousetrap from "mousetrap";
import "mousetrap-global-bind";
import "mousetrap-pause";
import Turbolinks from "turbolinks";

document.addEventListener("turbolinks:load", () => {
  // check for Rails web console in development
  if ($("#console").length > 0) {
    Mousetrap.pause();
  }
});

Mousetrap.bind("/", () => {
  $("#subnav-top input").focus();
  return false;
});

Mousetrap.bind("a", () => {
  Turbolinks.visit("/agencies");
  return false;
});

Mousetrap.bind("h", () => {
  Turbolinks.visit("/hosts");
  return false;
});

Mousetrap.bind("e", () => {
  Turbolinks.visit("/events");
  return false;
});

Mousetrap.bind("c", () => {
  Turbolinks.visit("/contacts");
  return false;
});

Mousetrap.bind("m", () => {
  Turbolinks.visit("/");
  return false;
});

Mousetrap.bind("n", () => {
  Turbolinks.visit(`${window.location.pathname}/new`);
  return false;
});

Mousetrap.bindGlobal("escape", () => {
  $("input[type=text]").blur();
  return false;
});
